import React, { useState, useEffect, useRef, useContext, useReducer } from "react";
import { useTranslation } from "react-i18next";
import Plan from "./plan.js";
import Loading from "../../Loading/loading";
import "./home.css";
import { Toast } from "primereact/toast";
import { ConfirmDialog } from 'primereact/confirmdialog';
import { AuthContext } from "../../Header/auth - context";
import { Button } from "primereact/button";
import { MultiSelect } from "primereact/multiselect";
import { useSelector, useDispatch } from "react-redux";
import CustomDropdown from "../../custom/customDropdown";

const useHomeDataReducer = (state, action) => {
  switch (action.type) {
    case 'PLAN_DB1':   return { ...state, planDB1: action.value };
    case 'PLAN_DB2':   return { ...state, planDB2: action.value };
    case 'PLAN_DB3':   return { ...state, planDB3: action.value };
    case 'USERS_DB':   return { ...state, usersDB: action.value };
    case 'LOAD':       return { ...state, load: action.value };
    case 'OPERATER':   return { ...state, operater: action.value };
    case 'COMPANY':    return { ...state, company: action.value };
    case 'PRIORITET':  return { ...state, prioritetDB: action.value };
    case 'RENDER':     return { ...state, render: action.value };
    default:           return state;
  }
};

const initialState = {
  planDB1: [], planDB2: [], planDB3: [],
  usersDB: [], load: true, operater: null,
  company: null, prioritetDB: [], render: false,
};

const Home = () => {
  const { t } = useTranslation();
  const company   = useSelector(state => state.company);
  const userData  = useSelector(state => state.user);
  const userRole  = useSelector(state => state.user_role);
  const dispatch  = useDispatch();
  const [stateHomeReducer, dispatchHomeState] = useReducer(useHomeDataReducer, initialState);

  const [planInsert,    setPlanInsert]    = useState('');
  const [userDrop,      setUserDrop]      = useState([]);
  const [prioritetDrop, setPrioritetDrop] = useState(null);
  const [stateTicketDB, setStateTicketDB] = useState([]);
  const [planText,      setPlanText]      = useState('');
  const [dragOverCol,   setDragOverCol]   = useState(null);
  const [planImages,    setPlanImages]    = useState([]);

  const toast            = useRef(null);
  const fileInputPlanRef = useRef(null);
  const auth  = useContext(AuthContext);

  const handleErrors = (response) => {
    if (response.ok) return response.json();
    throw response;
  };

  const renderFunction = () => {
    dispatchHomeState({ type: 'RENDER', value: !stateHomeReducer.render });
  };

  const handleDrop = (e, targetStanje) => {
    e.preventDefault();
    setDragOverCol(null);
    const planId = parseInt(e.dataTransfer.getData('planId'));
    const sourceStanje = parseInt(e.dataTransfer.getData('sourceStanje'));
    if (!planId || sourceStanje === targetStanje) return;
    const sourceKey = `PLAN_DB${sourceStanje}`;
    const sourceArr = stateHomeReducer[`planDB${sourceStanje}`];
    const sourcePlan = sourceArr?.find(p => p.id === planId);
    if (!sourcePlan) return;
    const sourceAssignees = sourcePlan.AssigneeIds
      ? sourcePlan.AssigneeIds.split(',').map(Number)
      : [sourcePlan.Task_za].filter(Boolean);
    fetch(process.env.REACT_APP_BACKEND_URL + '/plan', {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
      body: JSON.stringify({ id: planId, text: sourcePlan.Text, state: targetStanje, Task_za: sourceAssignees, prioritet: sourcePlan.Prioritet }),
    })
      .then(handleErrors)
      .then(() => renderFunction())
      .catch(error => error.json?.().then(m => toast.current.show({ severity: 'error', summary: 'Error', detail: m.message, life: 3000 })));
  };

  useEffect(() => {
    if (userData && company) {
      dispatchHomeState({ type: 'OPERATER', value: userData.userId });
      dispatchHomeState({ type: 'COMPANY',  value: company.companyId });
    }

    const postOpts = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
    };
    const getOpts = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
    };

    if (company !== null) {
      fetch(process.env.REACT_APP_BACKEND_URL + '/plan', postOpts)
        .then(handleErrors)
        .then((result) => {
          const db1 = [], db2 = [], db3 = [];
          const userId = userData?.userId;
          let noviCount = 0;
          for (const p of result) {
            /* Badge broji NEZAVRSENE zadatke (NOVI + U RADU) koji stoje na meni —
               isto pravilo koje koristi /plan/novi_count. Ranije se brojalo samo
               Stanje 1, pa je prevlacenje jednog zadatka u ZAVRSEN obaralo badge
               na broj novih. */
            // Task_od uz tip: task mobilnog naloga sa istim brojem nije „moj".
            const mojZadatak = (p.Task_od === userId && (p.Task_od_tip || 'OPERATER') === 'OPERATER') || p.Task_za === userId
                || (p.AssigneeIds || '').split(',').map(Number).includes(userId);

            if (p.Stanje === 1) db1.push(p);
            else if (p.Stanje === 2) db2.push(p);
            else if (p.Stanje === 3) db3.push(p);

            if (mojZadatak && (p.Stanje === 1 || p.Stanje === 2)) noviCount++;
          }
          dispatchHomeState({ type: 'PLAN_DB1', value: db1 });
          dispatchHomeState({ type: 'PLAN_DB2', value: db2 });
          dispatchHomeState({ type: 'PLAN_DB3', value: db3 });
          dispatchHomeState({ type: 'LOAD',     value: false });
          dispatch({ type: 'PLAN_NOVI_SET', value: noviCount });
        })
        .catch((error) => {
          error.json?.().then((m) => toast.current.show({ severity: 'error', summary: 'Error', detail: m.message, life: 3000 }));
          dispatchHomeState({ type: 'LOAD', value: false });
        });

      fetch(process.env.REACT_APP_BACKEND_URL + '/users', postOpts)
        .then(handleErrors)
        .then((result) => {
          const users = result.users.map(u => ({ label: `${u.name} ${u.surname}`, value: u.id }));
          dispatchHomeState({ type: 'USERS_DB', value: users });
        })
        .catch((error) => {
          error.json?.().then((m) => toast.current.show({ severity: 'error', summary: 'Error', detail: m.message, life: 3000 }));
        });
    }

    fetch(process.env.REACT_APP_BACKEND_URL + '/plan/prioritet_plana', getOpts)
      .then(handleErrors)
      .then((result) => {
        const prioritet = result.map(t => ({ label: t.naziv_prioriteta, value: t.id }));
        dispatchHomeState({ type: 'PRIORITET', value: prioritet });
      })
      .catch((error) => {
        error.json?.().then((m) => toast.current.show({ severity: 'error', summary: 'Error', detail: m.message, life: 3000 }));
      });

    fetch(process.env.REACT_APP_BACKEND_URL + '/plan/stanje_plana', getOpts)
      .then(handleErrors)
      .then((result) => {
        const states = result.map(s => ({ label: s.Status, value: s.id }));
        setStateTicketDB(states);
      })
      .catch((error) => {
        error.json?.().then((m) => toast.current.show({ severity: 'error', summary: 'Error', detail: m.message, life: 3000 }));
      });

  }, [planInsert, stateHomeReducer.render]);

  const handlePlanTextPaste = async (e) => {
    const items = e.clipboardData?.items;
    if (!items) return;
    for (const item of items) {
      if (item.type.startsWith('image/')) {
        const file = item.getAsFile();
        const reader = new FileReader();
        reader.onload = (ev) => setPlanImages(prev => [...prev, { data: ev.target.result, filename: file.name || 'paste.png' }]);
        reader.readAsDataURL(file);
      }
    }
  };

  const handlePlanFileSelect = (e) => {
    for (const file of Array.from(e.target.files)) {
      const reader = new FileReader();
      reader.onload = (ev) => setPlanImages(prev => [...prev, { data: ev.target.result, filename: file.name }]);
      reader.readAsDataURL(file);
    }
    e.target.value = '';
  };

  const setPlanHandler = async () => {
    if (planText.trim().length < 2 || !userDrop?.length || !prioritetDrop) {
      toast.current.show({ severity: 'warn', summary: 'Upozorenje', detail: 'Unesite tekst zadatka, korisnika i prioritet!', life: 3000 });
      return;
    }
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
      body: JSON.stringify({ text: planText.trim(), taskZa: userDrop, prioritet_id: prioritetDrop }),
    };
    try {
      const data = await fetch(process.env.REACT_APP_BACKEND_URL + '/plan/createPlan', requestOptions).then(handleErrors);

      if (planImages.length > 0 && data.id) {
        for (const img of planImages) {
          await fetch(process.env.REACT_APP_BACKEND_URL + '/plan/slike/add', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
            body: JSON.stringify({ plan_id: data.id, komentar_id: null, slika: img.data, filename: img.filename }),
          }).catch(() => {});
        }
        setPlanImages([]);
      }

      setPlanInsert(Date.now());
      setPlanText('');
      setUserDrop([]);
      setPrioritetDrop(null);
      toast.current.show({ severity: 'success', summary: 'Uspešno unet zadatak!', life: 3000 });
    } catch (error) {
      error.json?.().then((m) => toast.current.show({ severity: 'error', summary: 'Error', detail: m.message, life: 3000 }));
    }
  };

  const { planDB1, planDB2, planDB3, load, prioritetDB, usersDB } = stateHomeReducer;

  const currentUserId = userData?.userId ?? null;
  const userRoleId    = userRole?.roleId ?? null;

  const colProps = (db, dbKey) => ({
    prioritet:      prioritetDB,
    users:          usersDB,
    planAll:        db,
    setPlan:        dispatchHomeState,
    render:         renderFunction,
    stateTicketDB,
    dbKey,
    currentUserId,
    userRoleId,
  });

  return (
    <main>
      <div id="workstation">

        {/* ── Input area ── */}
        <div id="board_input">
          <div className="textarea">
            <textarea
              placeholder={t('home.unesiZadatak')}
              value={planText}
              onChange={e => setPlanText(e.target.value)}
              onPaste={handlePlanTextPaste}
              onKeyDown={e => { if (e.key === 'Enter' && e.ctrlKey) setPlanHandler(); }}
            />
            <div className="board_dropdowns">
              <MultiSelect
                value={userDrop}
                options={usersDB}
                onChange={e => setUserDrop(e.value)}
                placeholder={t('home.zaKorisnika')}
                optionLabel="label"
                filter
                showClear
                filterPlaceholder="Pretraži korisnike..."
                display="chip"
                className="plan_dropdown"
              />
              <CustomDropdown
                value={prioritetDrop}
                options={prioritetDB}
                onChange={e => setPrioritetDrop(e.target.value)}
                placeholder={t('home.prioritet')}
                optionLabel="label"
                filter={false}
                showClear={false}
                className="plan_dropdown"
              />
            </div>
          </div>
          <div className="board_unos">
            <input type="file" accept="image/*" multiple style={{ display: 'none' }} ref={fileInputPlanRef} onChange={handlePlanFileSelect} />
            <button className="ct-img-btn board-img-btn" onClick={() => fileInputPlanRef.current?.click()} title="Dodaj sliku uz zadatak">
              <i className="pi pi-image" />
            </button>
            <Button
              onClick={setPlanHandler}
              label="UNESI"
              icon="pi pi-plus"
              className="p-button-raised p-button-success p-button"
              id="btn"
              tooltip="Ctrl+Enter za brzi unos"
              tooltipOptions={{ position: 'top' }}
            />
          </div>
        </div>

        {planImages.length > 0 && (
          <div className="board-pending-slike-bar">
            {planImages.map((img, i) => (
              <div key={i} className="board-pending-slika">
                <img src={img.data} alt={img.filename} className="board-slika-thumb" />
                <button className="ct-slika-del" onClick={() => setPlanImages(prev => prev.filter((_, idx) => idx !== i))}>×</button>
              </div>
            ))}
          </div>
        )}

        {/* ── Board ── */}
        <div id="boardPR">
          <Toast ref={toast} />
          <ConfirmDialog />
          {load && <Loading />}

          <div className="kolona_naslov">
            <div className="kol-novi">
              <span>NOVI</span>
              <span className="kolona_count">{planDB1.length}</span>
            </div>
            <div className="kol-uradju">
              <span>U RADU</span>
              <span className="kolona_count">{planDB2.length}</span>
            </div>
            <div className="kol-zavrseni">
              <span>ZAVRŠENI</span>
              <span className="kolona_count">{planDB3.length}</span>
            </div>
          </div>

          <section
            className={`kolona_plan${dragOverCol === 1 ? ' drag-over' : ''}`}
            onDragOver={(e) => { e.preventDefault(); setDragOverCol(1); }}
            onDragLeave={() => setDragOverCol(null)}
            onDrop={(e) => handleDrop(e, 1)}
          >
            {planDB1.map((plan, i) => (
              <Plan key={plan.id} index={i} date={plan.DateEntered} ID={plan.id}
                text={plan.Text} plan={plan} {...colProps(planDB1, 'PLAN_DB1')} />
            ))}
          </section>

          <section
            className={`kolona_plan${dragOverCol === 2 ? ' drag-over' : ''}`}
            onDragOver={(e) => { e.preventDefault(); setDragOverCol(2); }}
            onDragLeave={() => setDragOverCol(null)}
            onDrop={(e) => handleDrop(e, 2)}
          >
            {planDB2.map((plan, i) => (
              <Plan key={plan.id} index={i} date={plan.DateEntered} ID={plan.id}
                text={plan.Text} plan={plan} {...colProps(planDB2, 'PLAN_DB2')} />
            ))}
          </section>

          <section
            className={`kolona_plan${dragOverCol === 3 ? ' drag-over' : ''}`}
            onDragOver={(e) => { e.preventDefault(); setDragOverCol(3); }}
            onDragLeave={() => setDragOverCol(null)}
            onDrop={(e) => handleDrop(e, 3)}
          >
            {planDB3.map((plan, i) => (
              <Plan key={plan.id} index={i} date={plan.DateEntered} ID={plan.id}
                text={plan.Text} plan={plan} {...colProps(planDB3, 'PLAN_DB3')} />
            ))}
          </section>
        </div>
      </div>
    </main>
  );
};

export default Home;
